export var MetricsIntervalType;
(function (MetricsIntervalType) {
    MetricsIntervalType["HOUR"] = "HOUR";
    MetricsIntervalType["DAY"] = "DAY";
    MetricsIntervalType["WEEK"] = "WEEK";
})(MetricsIntervalType || (MetricsIntervalType = {}));
